import { STORAGE_KEY } from '../config.js'

// localStorage persistence. The saved snapshot is the same shape as the
// exported project JSON (exportKit reuses buildSnapshot), version-tagged so
// future schema changes can migrate or bail out cleanly.

export function buildSnapshot(state) {
  return {
    app: 'pgn-sync',
    version: 1,
    savedAt: new Date().toISOString(),
    pgn: state.pgn.raw,
    stamps: state.stamps,
    selection: state.selection,
    video: {
      fileName: state.video.fileName,
      size: state.video.size,
      duration: state.video.duration,
      width: state.video.width,
      height: state.video.height,
      fps: state.video.fps,
    },
    overlay: { ...state.overlay },
    prefs: { ...state.prefs },
    scaffolded: state.scaffolded,
  }
}

export function saveProject(snapshot) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot))
    return true
  } catch {
    return false
  }
}

export function loadProject() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const snapshot = JSON.parse(raw)
    if (snapshot?.app !== 'pgn-sync' || snapshot?.version !== 1) return null
    return snapshot
  } catch {
    return null
  }
}

export function clearProject() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
